import { useTranslation } from "react-i18next";
import { Card, CardContent } from "@/components/ui/card";
import { Workflow, ArrowRight } from "lucide-react";
import { useLanguageNavigation } from "@/components/LanguageRouter";

export function AiCodingSuiteCallout() {
  const { t } = useTranslation();
  const { getLocalizedPath } = useLanguageNavigation();

  const suiteTools = t("tddSkill.suite.tools", { returnObjects: true }) as Array<{
    name: string;
    description: string;
    link: string;
  }>;

  return (
    <Card className="bg-primary/5 border-primary/20">
      <CardContent className="pt-6">
        <div className="flex items-start gap-4">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
            <Workflow className="h-5 w-5" />
          </div>
          <div>
            <h3 className="font-semibold text-foreground mb-2">
              {t("tddSkill.suite.title")}
            </h3>
            <p className="text-muted-foreground mb-4">
              {t("tddSkill.suite.description")}
            </p>
            <div className="grid gap-3 sm:grid-cols-3">
              {Array.isArray(suiteTools) &&
                suiteTools.map((tool) => (
                  <a
                    key={tool.name}
                    href={getLocalizedPath(tool.link)}
                    className="flex items-center gap-2 text-sm font-medium text-primary hover:underline"
                  >
                    <ArrowRight className="h-3.5 w-3.5" />
                    {tool.name}
                  </a>
                ))}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}